import { ReactNode } from "react";

function Page(props: {
    mask: boolean;
    children?: ReactNode;
}) {
    return (
        <div style={{
            backgroundColor: props.mask ? 'rgba(128,128,128,0.5)' : '',
            position: "fixed",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            width: "100%",
            height: "100%",
            overflow: "hidden",
            zIndex: 9999,
        }}>
            {props.children}
        </div>
    );
}

export default Page;